import { route } from "preact-router";
import { Navbar } from "../components/layout/Navbar";

export function NotFound() {
  return (
    <div class="app-shell">
      <Navbar />
      <main class="not-found-main">
        <h1 class="not-found-title">404</h1>
        <p class="not-found-desc">This page doesn't exist.</p>
        <a class="text-button" href="/" onClick={(e) => { e.preventDefault(); route("/"); }}>
          Back to Home
        </a>
      </main>
    </div>
  );
}
